var _path, _path2, _polygon, _polygon2, _polygon3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -41.5081 100.145)",
    style: {
      fill: "#E0E0E0"
    },
    cx: 409.298,
    cy: 228.321,
    rx: 19.839,
    ry: 19.839
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -41.4255 100.8544)",
    style: {
      fill: "#F0F0F0"
    },
    cx: 412.386,
    cy: 228.321,
    rx: 19.839,
    ry: 19.839
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -55.9836 175.1934)",
    style: {
      fill: "#F5F5F5"
    },
    cx: 412.386,
    cy: 228.321,
    rx: 15.254,
    ry: 15.254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M425.324,228.321c0-8.034-6.214-14.602-14.096-15.195c0.384-0.029,0.767-0.059,1.158-0.059 c8.424,0,15.254,6.829,15.254,15.254s-6.829,15.254-15.254,15.254c-0.391,0-0.774-0.03-1.158-0.059 C419.109,242.922,425.324,236.354,425.324,228.321z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "412.386,218.617 410.207,225.322 403.157,225.322 408.861,229.466 406.682,236.171  412.386,232.027 418.089,236.171 415.911,229.466 421.614,225.322 414.564,225.322  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M420.626,337.916l-58.523,12.439c-3.706,0.788-7.348-1.578-8.136-5.284l-2.189-10.3 c-0.788-3.706,1.578-7.348,5.283-8.136l58.523-12.439c3.706-0.788,7.348,1.578,8.136,5.284l2.189,10.3 C426.697,333.486,424.332,337.128,420.626,337.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M389.629,325.244c-2.93-1.903-6.848-1.07-8.75,1.86c-1.903,2.93-1.07,6.848,1.86,8.75 c2.592,1.683,5.955,1.222,8.014-0.935c0.107,0.303,0.287,0.583,0.577,0.771l5.064,3.289c0.699,0.454,1.634,0.255,2.088-0.444 c0.454-0.699,0.255-1.634-0.444-2.088l-5.064-3.289c-0.29-0.188-0.619-0.24-0.939-0.214 C393.168,330.186,392.221,326.927,389.629,325.244z M389.955,332.998c-1.353,2.083-4.138,2.675-6.221,1.322 c-2.083-1.353-2.675-4.138-1.322-6.22c1.353-2.083,4.138-2.675,6.221-1.322C390.716,328.13,391.308,330.915,389.955,332.998z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M123.824,322.422c-8.936,3.064-13.696,12.793-10.632,21.729c2.377,6.932,16.475,16.315,22.68,20.176 c1.522,0.947,3.534,0.257,4.154-1.424c2.53-6.856,7.904-22.916,5.527-29.848C142.488,324.118,132.76,319.358,123.824,322.422z  M132.014,346.306c-4.255,1.459-8.887-0.807-10.345-5.062c-1.459-4.255,0.808-8.886,5.062-10.345 c4.255-1.459,8.886,0.807,10.345,5.062C138.535,340.215,136.268,344.847,132.014,346.306z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M120.835,137.458h-8.146c-1.917,0-3.706,0.961-4.764,2.559l-1.192,1.801 c-0.971,1.466-2.612,2.348-4.371,2.348H81.349c-1.885,0-3.413,1.528-3.413,3.413v32.812h47.376v-36.224l-0.417-3.15 C124.625,138.979,122.889,137.458,120.835,137.458z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.489,
    y: 148.311,
    style: {
      fill: "#FAFAFA"
    },
    width: 40.269,
    height: 27.537
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M125.312,180.39H77.936l-6.949-25.309c-0.526-1.917,0.916-3.809,2.904-3.809h38.824 c2.718,0,5.1,1.816,5.82,4.437L125.312,180.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M195.971,105.44h33.7c1.814,0,3.284-1.536,3.284-3.431l0,0h-40.268l0,0 C192.687,103.904,194.157,105.44,195.971,105.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M219.515,105.44h33.7c1.814,0,3.284-1.536,3.284-3.431l0,0h-40.268l0,0 C216.232,103.904,217.702,105.44,219.515,105.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M195.699,104.391h20.546c0.536,0,0.911-0.552,0.734-1.081l-11.267-33.63 c-0.31-0.926-1.147-1.547-2.087-1.547h-20.546c-0.536,0-0.911,0.552-0.734,1.081l11.267,33.63 C193.922,103.771,194.759,104.391,195.699,104.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M194.707,104.391h20.546c0.536,0,0.911-0.552,0.734-1.081l-11.267-33.63 c-0.31-0.926-1.147-1.547-2.087-1.547h-20.546c-0.536,0-0.911,0.552-0.734,1.081l11.267,33.63 C192.931,103.771,193.768,104.391,194.707,104.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M197.004,86.263c0.262,1.289,1.115,2.333,1.905,2.333s1.218-1.045,0.956-2.333 c-0.262-1.289-1.115-2.333-1.905-2.333S196.742,84.974,197.004,86.263z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M241.648,85.774c2.553-4.801,0.73-10.763-4.071-13.316c-4.801-2.553-10.763-0.73-13.316,4.071 c-2.229,4.192-1.121,9.268,2.391,12.188l-0.449,5.132l4.004-3.242C234.592,91.886,239.419,89.966,241.648,85.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M238.744,77.171H227.7c-0.215,0-0.39,0.175-0.39,0.39v7.824c0,0.215,0.174,0.39,0.39,0.39h11.044 c0.215,0,0.39-0.175,0.39-0.39v-7.824C239.134,77.345,238.96,77.171,238.744,77.171z M238.558,84.79l-3.318-3.318l3.318-3.318 V84.79z M238.15,77.747l-3.318,3.318l-1.611,1.61l-4.928-4.929H238.15z M227.886,78.154l3.318,3.318l-3.318,3.318V78.154z  M228.293,85.198l3.318-3.318l1.61,1.61l1.611-1.61l3.318,3.318H228.293z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "403.079,176.853 387.448,165.112 403.079,153.372 404.378,155.101 391.048,165.112  404.378,175.124  "
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBEBEB"
    },
    cx: 389.248,
    cy: 165.112,
    r: 3.057
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M406.98,154.236c0,1.688-1.368,3.057-3.057,3.057s-3.057-1.369-3.057-3.057 c0-1.688,1.368-3.057,3.057-3.057S406.98,152.548,406.98,154.236z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBEBEB"
    },
    cx: 403.923,
    cy: 176.213,
    r: 3.057
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M145.416,329.136C119,307.317,39.663,245.657,66.695,178.003 c28.171-70.505,85.284-60.565,153.135-22.889c63.363,35.184,75.187-43.416,160.894,4.175 c72.566,40.295,79.696,178.07-44.94,217.733C260.112,401.103,175.273,353.797,145.416,329.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M145.416,329.136C119,307.317,39.663,245.657,66.695,178.003 c28.171-70.505,85.284-60.565,153.135-22.889c63.363,35.184,75.187-43.416,160.894,4.175 c72.566,40.295,79.696,178.07-44.94,217.733C260.112,401.103,175.273,353.797,145.416,329.136z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__1_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 245.178,
    cy: 412.391,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M179.896,133.206h23.684l23.884,273.001H203.78c-10.978,0-20.656-8.9-21.617-19.878 l-20.406-233.245C160.797,142.105,168.918,133.206,179.896,133.206z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M165.228,160.587c-0.092-1.052-1.02-1.905-2.072-1.905c-1.052,0-1.83,0.853-1.739,1.905 l1.6,18.29c0.092,1.052,1.02,1.905,2.072,1.905c1.052,0,1.831-0.853,1.738-1.905L165.228,160.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M165.228,160.587c-0.092-1.052-1.02-1.905-2.072-1.905 c-1.052,0-1.83,0.853-1.739,1.905l1.6,18.29c0.092,1.052,1.02,1.905,2.072,1.905c1.052,0,1.831-0.853,1.738-1.905 L165.228,160.587z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M208.63,406.207h97.587c10.978,0,19.099-8.9,18.139-19.878l-20.406-233.245 c-0.96-10.978-10.639-19.878-21.617-19.878h-97.587c-10.978,0-19.099,8.9-18.139,19.878l20.406,233.245 C187.973,397.307,197.652,406.207,208.63,406.207z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M185.145,137.766h25.365c1.661,0,3.172,1.235,3.526,2.883l0.171,0.794 c0.866,4.024,4.555,7.04,8.612,7.04h24.114c4.057,0,7.218-3.016,7.38-7.04l0.032-0.794c0.066-1.648,1.361-2.883,3.022-2.883 h25.365c8.46,0,15.917,6.858,16.657,15.317l20.406,233.245c0.74,8.46-5.517,15.317-13.977,15.317h-97.587 c-8.46,0-15.917-6.858-16.658-15.317l-20.406-233.245C170.427,144.624,176.685,137.766,185.145,137.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M185.145,137.766h25.365c1.661,0,3.172,1.235,3.526,2.883l0.171,0.794 c0.866,4.024,4.555,7.04,8.612,7.04h24.114c4.057,0,7.218-3.016,7.38-7.04l0.032-0.794c0.066-1.648,1.361-2.883,3.022-2.883 h25.365c8.46,0,15.917,6.858,16.657,15.317l20.406,233.245c0.74,8.46-5.517,15.317-13.977,15.317h-97.587 c-8.46,0-15.917-6.858-16.658-15.317l-20.406-233.245C170.427,144.624,176.685,137.766,185.145,137.766z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.066,140.351c0.094,1.07,1.037,1.938,2.108,1.938c1.071,0,1.862-0.868,1.769-1.938 c-0.094-1.07-1.037-1.938-2.108-1.938C240.764,138.413,239.973,139.28,240.066,140.351z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.154,138.413c0.766,0,5.88,0,6.646,0c1.07,0,2.014,0.868,2.108,1.938c0.094,1.07-0.698,1.938-1.769,1.938 c-0.665,0-5.981,0-6.646,0c-1.071,0-2.014-0.868-2.108-1.938C224.292,139.28,225.084,138.413,226.154,138.413z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "288.361,148.446 286.309,148.446 286.129,146.393 288.182,146.393  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "284.077,146.393 284.257,148.446 282.204,148.446 282.025,146.393 281.845,144.341 283.898,144.341  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "279.614,142.289 279.793,144.341 279.973,146.393 280.152,148.446 278.1,148.446 277.921,146.393  277.741,144.341 277.562,142.289  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M182.344,142.426l0.527,6.02h9.03l-0.132-1.505h1.003l-0.263-3.01h-1.003l-0.132-1.505H182.344z  M187.492,143.931h3.01l0.263,3.01h-3.01L187.492,143.931z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.929,394.914c19.555,0,39.11,0,58.665,0c1.779,0,1.54-2.764-0.242-2.764c-19.555,0-39.11,0-58.665,0 C224.909,392.15,225.148,394.914,226.929,394.914L226.929,394.914z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M355.483,237.351h-62.666c-3.953,0-6.878-3.205-6.532-7.158l3.378-38.609 c0.346-3.953,3.831-7.158,7.785-7.158h62.666c3.953,0,6.878,3.205,6.532,7.158l-3.378,38.609 C362.922,234.147,359.436,237.351,355.483,237.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M355.483,237.351h-62.666c-3.953,0-6.878-3.205-6.532-7.158l3.378-38.609 c0.346-3.953,3.831-7.158,7.785-7.158h62.666c3.953,0,6.878,3.205,6.532,7.158l-3.378,38.609 C362.922,234.147,359.436,237.351,355.483,237.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M355.236,234.501h-61.674c-2.582,0-4.492-2.093-4.266-4.675l2.963-33.866 c0.226-2.582,2.502-4.675,5.084-4.675h61.674c2.582,0,4.491,2.093,4.266,4.675l-2.963,33.866 C360.094,232.408,357.818,234.501,355.236,234.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M296.413,187.901c-0.064,0.731-0.708,1.323-1.439,1.323 c-0.731,0-1.271-0.592-1.207-1.323c0.064-0.731,0.708-1.323,1.439-1.323C295.936,186.578,296.477,187.17,296.413,187.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M300.53,187.901c-0.064,0.731-0.708,1.323-1.439,1.323 c-0.731,0-1.271-0.592-1.207-1.323c0.064-0.731,0.708-1.323,1.439-1.323C300.054,186.578,300.594,187.17,300.53,187.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M304.648,187.901c-0.064,0.731-0.708,1.323-1.439,1.323 c-0.731,0-1.271-0.592-1.207-1.323c0.064-0.731,0.708-1.323,1.439-1.323C304.171,186.578,304.711,187.17,304.648,187.901z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1
    },
    points: "321.47,224.922 299.284,224.922 301.388,200.865 323.574,200.865  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M353.158,203.538h-23.522c-0.738,0-1.284-0.598-1.22-1.336l0,0 c0.065-0.738,0.715-1.337,1.453-1.337h23.522c0.738,0,1.284,0.598,1.22,1.337l0,0 C354.547,202.94,353.896,203.538,353.158,203.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M348.681,208.884h-19.513c-0.738,0-1.284-0.598-1.22-1.337l0,0 c0.065-0.738,0.715-1.337,1.453-1.337h19.513c0.738,0,1.284,0.598,1.22,1.337l0,0 C350.069,208.286,349.419,208.884,348.681,208.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M349.817,214.23H328.7c-0.738,0-1.284-0.598-1.219-1.337l0,0 c0.065-0.738,0.715-1.336,1.453-1.336h21.117c0.738,0,1.284,0.598,1.22,1.336l0,0 C351.206,213.632,350.555,214.23,349.817,214.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M346.943,219.576h-18.711c-0.738,0-1.284-0.598-1.22-1.337l0,0 c0.065-0.738,0.715-1.336,1.453-1.336h18.711c0.738,0,1.284,0.598,1.22,1.336l0,0 C348.332,218.978,347.681,219.576,346.943,219.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M349.683,224.922h-21.919c-0.738,0-1.284-0.598-1.219-1.337l0,0 c0.065-0.738,0.715-1.336,1.453-1.336h21.918c0.738,0,1.284,0.598,1.22,1.336l0,0 C351.072,224.324,350.421,224.922,349.683,224.922z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M353.158,203.538h-23.522c-0.738,0-1.284-0.598-1.22-1.336l0,0 c0.065-0.738,0.715-1.337,1.453-1.337h23.522c0.738,0,1.284,0.598,1.22,1.337l0,0 C354.547,202.94,353.896,203.538,353.158,203.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M348.681,208.884h-19.513c-0.738,0-1.284-0.598-1.22-1.337l0,0 c0.065-0.738,0.715-1.337,1.453-1.337h19.513c0.738,0,1.284,0.598,1.22,1.337l0,0 C350.069,208.286,349.419,208.884,348.681,208.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.817,214.23H328.7c-0.738,0-1.284-0.598-1.219-1.337l0,0 c0.065-0.738,0.715-1.336,1.453-1.336h21.117c0.738,0,1.284,0.598,1.22,1.336l0,0 C351.206,213.632,350.555,214.23,349.817,214.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M346.943,219.576h-18.711c-0.738,0-1.284-0.598-1.22-1.337l0,0 c0.065-0.738,0.715-1.336,1.453-1.336h18.711c0.738,0,1.284,0.598,1.22,1.336l0,0 C348.332,218.978,347.681,219.576,346.943,219.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.683,224.922h-21.919c-0.738,0-1.284-0.598-1.219-1.337l0,0 c0.065-0.738,0.715-1.336,1.453-1.336h21.918c0.738,0,1.284,0.598,1.22,1.336l0,0 C351.072,224.324,350.421,224.922,349.683,224.922z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M316.252,207.002L316.252,207.002c-1.601-1.601-4.196-1.601-5.797,0l-2.086,2.086l-2.086-2.086 c-1.601-1.601-4.197-1.601-5.797,0c-1.601,1.601-1.601,4.196,0,5.797l7.884,7.884l7.884-7.884 C317.853,211.198,317.853,208.603,316.252,207.002z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M306.697,181.147h-32.528c-2.052,0-3.57-1.664-3.391-3.716l1.753-20.04 c0.18-2.052,1.989-3.716,4.041-3.716H309.1c2.052,0,3.57,1.663,3.391,3.716l-1.753,20.04 C310.558,179.484,308.749,181.147,306.697,181.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M306.697,181.147h-32.528c-2.052,0-3.57-1.664-3.391-3.716l1.753-20.04 c0.18-2.052,1.989-3.716,4.041-3.716H309.1c2.052,0,3.57,1.663,3.391,3.716l-1.753,20.04 C310.558,179.484,308.749,181.147,306.697,181.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.569,179.668h-32.013c-1.34,0-2.331-1.086-2.214-2.426l1.538-17.579 c0.117-1.34,1.299-2.426,2.639-2.426h32.013c1.34,0,2.331,1.086,2.214,2.426l-1.538,17.579 C309.091,178.581,307.909,179.668,306.569,179.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M276.036,155.479c-0.033,0.379-0.367,0.687-0.747,0.687s-0.66-0.308-0.627-0.687 c0.033-0.379,0.367-0.687,0.747-0.687S276.069,155.1,276.036,155.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M278.173,155.479c-0.033,0.379-0.368,0.687-0.747,0.687s-0.66-0.308-0.627-0.687 c0.033-0.379,0.368-0.687,0.747-0.687C277.926,154.793,278.206,155.1,278.173,155.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M280.31,155.479c-0.033,0.379-0.367,0.687-0.747,0.687s-0.66-0.308-0.627-0.687 c0.033-0.379,0.368-0.687,0.747-0.687S280.343,155.1,280.31,155.479z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -78.6779 163.895)",
    style: {
      fill: "#407BFF"
    },
    cx: 372.639,
    cy: 279.718,
    rx: 20.804,
    ry: 20.804
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -78.6779 163.895)",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    cx: 372.639,
    cy: 279.718,
    rx: 20.804,
    ry: 20.804
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M382.287,274.833c-0.132-1.292-0.626-2.432-1.586-3.348c-1.009-0.963-2.243-1.388-3.597-1.46 c-2.305-0.126-7.779-0.205-9.702,0.109c-2.196,0.357-3.636,1.64-4.243,3.808c-0.467,1.669-0.374,9.361-0.102,11.012 c0.372,2.256,1.705,3.702,3.941,4.278c1.547,0.399,9.151,0.348,10.858,0.071c2.257-0.365,3.71-1.691,4.296-3.923 C382.601,283.668,382.444,276.378,382.287,274.833z M380.482,284.635c-0.262,1.713-1.4,2.773-3.122,2.963 c-1.582,0.172-8.648,0.267-10.116-0.143c-1.404-0.391-2.207-1.357-2.439-2.77c-0.223-1.349-0.278-8.094-0.003-9.898 c0.259-1.699,1.395-2.758,3.108-2.951c1.738-0.194,7.991-0.216,9.655,0.04c1.71,0.261,2.77,1.401,2.957,3.126 C380.697,276.613,380.747,282.905,380.482,284.635z M372.64,274.687c-2.78-0.002-5.031,2.25-5.029,5.035 c0.001,2.77,2.246,5.019,5.018,5.024c2.783,0.006,5.04-2.244,5.041-5.024C377.672,276.937,375.423,274.687,372.64,274.687z  M372.605,282.969c-1.773-0.003-3.217-1.469-3.217-3.266c0.001-1.794,1.457-3.239,3.264-3.239c1.794,0,3.24,1.458,3.24,3.264 C375.891,281.532,374.432,282.97,372.605,282.969z M379.041,274.499c-0.002,0.654-0.523,1.172-1.178,1.172 c-0.655,0-1.172-0.516-1.177-1.171c-0.005-0.663,0.524-1.189,1.189-1.185C378.526,273.32,379.043,273.845,379.041,274.499z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "374.197,107.733 352.169,102.595 343.096,141.498 371.802,148.194 379.318,115.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "374.197,107.733 352.169,102.595 343.096,141.498 371.802,148.194  379.318,115.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    points: "374.197,107.733 372.639,114.412 379.317,115.969  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M371.961,120.913l-16.938-3.951c-0.46-0.107-0.745-0.566-0.638-1.026l0,0 c0.107-0.459,0.566-0.745,1.026-0.638l16.939,3.951c0.46,0.107,0.745,0.566,0.638,1.026l0,0 C372.88,120.734,372.42,121.02,371.961,120.913z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M368.035,123.506l-13.789-3.216c-0.46-0.107-0.745-0.567-0.638-1.026l0,0 c0.107-0.459,0.567-0.745,1.026-0.638l13.789,3.216c0.459,0.107,0.745,0.566,0.638,1.026l0,0 C368.954,123.327,368.494,123.613,368.035,123.506z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M367.561,126.904l-14.091-3.287c-0.459-0.107-0.745-0.566-0.638-1.026l0,0 c0.107-0.459,0.566-0.745,1.026-0.638l14.091,3.287c0.46,0.107,0.745,0.567,0.638,1.026l0,0 C368.48,126.726,368.021,127.011,367.561,126.904z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M369.632,130.896l-16.939-3.951c-0.459-0.107-0.745-0.566-0.638-1.026l0,0 c0.107-0.459,0.566-0.745,1.026-0.638l16.938,3.951c0.459,0.107,0.745,0.566,0.638,1.026l0,0 C370.551,130.717,370.092,131.003,369.632,130.896z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M365.706,133.489l-13.789-3.216c-0.46-0.107-0.745-0.566-0.638-1.026l0,0 c0.107-0.459,0.566-0.745,1.026-0.638l13.789,3.216c0.46,0.107,0.745,0.566,0.638,1.026l0,0 C366.625,133.31,366.166,133.596,365.706,133.489z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M365.233,136.887l-14.091-3.287c-0.459-0.107-0.745-0.566-0.638-1.026l0,0 c0.107-0.46,0.566-0.745,1.026-0.638l14.091,3.287c0.46,0.107,0.745,0.566,0.638,1.026l0,0 C366.152,136.709,365.692,136.994,365.233,136.887z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Twitter"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M293.326,109.149c-3.66-0.127-5.946-2.753-6.553-4.886 c1.018,0.194,2.022,0.153,3.019-0.091c0.026-0.005,0.051-0.023,0.101-0.046c-1.981-0.461-3.511-1.522-4.574-3.232 c-0.705-1.135-1.041-2.377-1.031-3.746c0.99,0.529,2.023,0.825,3.134,0.855c-1.49-1.074-2.49-2.476-2.899-4.27 c-0.406-1.792-0.142-3.497,0.755-5.102c3.815,4.492,8.641,6.955,14.526,7.357c-0.041-0.278-0.084-0.522-0.113-0.769 c-0.195-1.657,0.134-3.201,1.028-4.606c1.12-1.756,2.722-2.85,4.777-3.181c2.368-0.39,4.436,0.285,6.165,1.962 c0.117,0.112,0.214,0.15,0.376,0.112c1.446-0.316,2.811-0.837,4.095-1.575c0.03-0.018,0.063-0.036,0.094-0.048 c0.005-0.003,0.018-0.003,0.046-0.003c-0.557,1.636-1.571,2.898-3.014,3.832c1.364-0.15,2.665-0.514,3.92-1.056 c0.011,0.013,0.02,0.02,0.029,0.031c-0.27,0.354-0.529,0.715-0.809,1.056c-0.747,0.921-1.604,1.73-2.56,2.433 c-0.082,0.061-0.12,0.117-0.117,0.224c0.04,1.043-0.002,2.087-0.131,3.125c-0.271,2.189-0.882,4.275-1.814,6.271 c-0.965,2.056-2.223,3.919-3.806,5.553c-2.682,2.774-5.915,4.56-9.679,5.39c-1.289,0.285-2.599,0.43-3.921,0.468 c-4.062,0.12-7.815-0.891-11.27-3.023c-0.045-0.026-0.088-0.059-0.165-0.109c2.457,0.267,4.794-0.051,7.044-0.972 C291.171,110.615,292.278,109.971,293.326,109.149z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hashtag"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M149.203,94.628c-2.994-9.793-13.36-15.305-23.153-12.311c-9.793,2.994-15.305,13.36-12.311,23.153 c2.614,8.55,10.848,13.834,19.413,13.045l6.236,7.432l1.014-9.649C147.946,112.163,151.817,103.178,149.203,94.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136.78,95.833l-0.843,4.818l3.534-0.751l-0.23,3.171l-3.89,0.827l-0.849,4.763l-3.178,0.676 l0.848-4.763l-3.945,0.839l-0.849,4.763l-3.152,0.67l0.849-4.763l-3.535,0.752l0.202-3.165l3.919-0.833l0.869-4.823l-3.534,0.751 l0.229-3.171l3.892-0.827l0.849-4.763l3.151-0.67l-0.849,4.763l3.946-0.839l0.848-4.763l3.151-0.67l-0.849,4.763l3.562-0.757 l-0.202,3.165L136.78,95.833z M133.628,96.503l-3.946,0.839l-0.87,4.824l3.946-0.839L133.628,96.503z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Photo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 85.894,
    y: 261.401,
    transform: "matrix(0.9781 0.2079 -0.2079 0.9781 60.5973 -17.4832)",
    style: {
      fill: "#407BFF"
    },
    width: 55.151,
    height: 36.259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.894,
    y: 261.401,
    transform: "matrix(0.9781 0.2079 -0.2079 0.9781 60.5973 -17.4832)",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    width: 55.151,
    height: 36.259
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "104.608,279.322 85.049,292.024 117.309,298.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: "104.608,279.322 85.049,292.024 117.309,298.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "136.118,302.879 125.918,272.168 104.109,296.075  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M113.798,272.928c-0.38,1.787-2.137,2.928-3.924,2.548 c-1.787-0.38-2.928-2.137-2.548-3.924c0.38-1.787,2.137-2.928,3.924-2.548C113.037,269.384,114.177,271.141,113.798,272.928z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M137.443,304.183l-55.902-11.882l7.954-37.423l55.902,11.882L137.443,304.183z M83.913,290.761 l51.989,11.051l7.123-33.51L91.036,257.25L83.913,290.761z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Facebook"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -136.9054 270.8533)",
    style: {
      fill: "#407BFF"
    },
    cx: 90.722,
    cy: 215.883,
    rx: 18.228,
    ry: 18.228
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -136.9054 270.8533)",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    cx: 90.722,
    cy: 215.883,
    rx: 18.228,
    ry: 18.228
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M93.794,209.33c0.613-0.02,1.225-0.004,1.84-0.007 c0.075,0,0.15,0,0.252,0v-3.186c-0.327-0.033-0.669-0.08-1.012-0.098c-0.629-0.027-1.258-0.058-1.888-0.044 c-0.961,0.019-1.869,0.253-2.663,0.823c-0.911,0.655-1.411,1.574-1.601,2.661c-0.08,0.448-0.1,0.913-0.111,1.367 c-0.018,0.716-0.004,1.431-0.003,2.147v0.269h-3.05v3.559h3.033v8.951h3.706v-8.935h3.023c0.155-1.186,0.306-2.358,0.465-3.578 c-0.243,0-0.461-0.001-0.68,0c-0.859,0.003-2.833,0-2.833,0s0.009-1.766,0.03-2.531C92.331,209.68,92.954,209.36,93.794,209.33z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M230.272,196.997c0,0,3.303-2.283,5.581,0.355c2.277,2.637,0.844,8.515,0.844,8.515l-5.305-6.438 L230.272,196.997z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#803E3C"
    },
    d: "M302.412,232.475l-6.645-0.354c-1.285,5.491-2.597,11.173-4.393,16.153 c-0.448,1.239-0.952,2.42-1.461,3.476c-0.508,1.044-1.098,1.982-1.57,2.454c-0.224,0.245-0.263,0.105-0.337,0.115 c-0.335,0.054-1.305,0.081-2.342-0.046c-2.142-0.229-4.706-0.857-7.234-1.652c-2.55-0.786-5.146-1.722-7.731-2.749 c-2.597-1.003-5.179-2.122-7.772-3.235c-2.567-1.114-5.201-2.354-7.635-3.494l-6.067,11.987c2.804,1.468,5.486,2.679,8.279,3.913 c2.769,1.231,5.603,2.333,8.484,3.389c2.895,1.023,5.843,1.98,8.929,2.771c3.106,0.762,6.282,1.444,9.986,1.604 c1.874,0.036,3.875,0.017,6.372-0.702c0.629-0.193,1.275-0.424,1.96-0.762c0.331-0.156,0.682-0.348,1.048-0.582 c0.352-0.222,0.671-0.456,0.971-0.694c1.185-0.96,1.997-1.957,2.63-2.897c1.25-1.899,1.921-3.63,2.49-5.302 c0.563-1.667,0.924-3.286,1.228-4.874c0.606-3.173,0.881-6.263,1.005-9.331C302.729,238.583,302.681,235.596,302.412,232.475z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M240.621,255.064c3.87,7.936,32.185,13.061,32.185,13.061l5.273-20.386 c0,0-11.709-5.161-22.895-6.996C243.698,238.858,236.374,246.354,240.621,255.064z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M295.735,232.46l1.756-11.461l8.388,6.169c0,0-2.063,10.373-6.209,9.134L295.735,232.46z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "303.728,214.102 309.14,221.855 305.879,227.167 297.491,220.999  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M258.74,249.855l-4.049,1.449l-0.84,2.984l0.56,4.827l3.722,5.446 c5.025,1.512,9.827,2.583,12.5,3.135C266.262,258.985,258.74,249.855,258.74,249.855z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M220.635,316.975c0,0-0.394,32.669,29.239,25.897c28.237-6.453,19.326-38.076,19.326-38.076 L220.635,316.975z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M249.874,339.139c-9.719-7.931-38.525-27.135-48.525-12.763 c-11.172,16.057,14.36,55.279,56.83,40.581C265.038,364.584,271.037,356.408,249.874,339.139z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M285.933,316.975c41.33-7.37,43.677,5.13,36.567,15.734c-7.11,10.604-30.687,35.536-72.626,32.882 C234.28,364.604,234.037,326.23,285.933,316.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M255.907,342.872c0,0,2.214-4.995,5.116-8.475c2.902-3.48,3.256,6.558,16.017,0 c12.762-6.558,21.704-13.572,31.578-16.184c9.874-2.613-7.599,15.219-7.599,15.219l-30.972,17.026L255.907,342.872z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "256.69,365.088 241.385,370.962 242.667,363.227 255.302,354.966  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M331.555,324.06c-1.248-8.791-15.585-12.298-27.58-2.873c-9.866,7.751-45.14,30.65-56.533,38.126 l2.406,9.265c10.474-3.969,31.036-11.774,45.769-17.446C316.176,343.216,332.803,332.851,331.555,324.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M248.078,337.718c-5.077-10.773-15.892-12.892-22.026-13.179 C234.533,328.101,242.936,333.75,248.078,337.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M266.489,362.262c9.541-3.628,20.361-7.754,29.128-11.13c0.334-0.129,0.664-0.26,0.996-0.39 l-25.451-6.757c-8.624,5.765-16.676,11.068-21.292,14.097L266.489,362.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M205.34,343.606c0,0,33.143,28.078,45.273,10.08l-40.049-15.236l-4.498-2.031L205.34,343.606z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "290.692,362.841 306.103,364.826 304.481,356.308 288.69,352.199  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M301.073,354.025c-7.556-1.949-24.683-6.249-35.261-10.379 c-14.269-5.571-50.642-20.662-62.635-13.6c-8.298,4.886,0.295,12.134,0.295,12.134s3.875,6.704,34.279,13.1 c21.734,4.572,48.602,7.977,62.162,9.547L301.073,354.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M304.916,365.099l-2.304-9.486c-0.087-0.358,0.085-0.728,0.415-0.891l7.301-3.59 c0.645-0.323,1.43-0.062,1.753,0.583c0.041,0.083,0.074,0.17,0.097,0.259c0.771,3.434,1.323,6.52,2.363,10.776 c1.222,5.024,1.513,3.603,3.032,9.489c0.911,3.547-2.975,5.182-3.541,3.721c-2.547-6.695-4.807-6.906-7.926-8.97 C305.491,366.528,305.068,365.854,304.916,365.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M243.924,370.135l1.677-9.642c0.063-0.363-0.133-0.722-0.474-0.863l-7.541-3.107 c-0.667-0.281-1.435,0.033-1.715,0.699c-0.036,0.086-0.063,0.175-0.08,0.266c-0.544,3.486-0.892,6.61-1.65,10.936 c-0.89,5.106-1.275,3.704-2.405,9.693c-0.677,3.609,3.319,4.986,3.788,3.488c2.105-6.866,4.351-7.226,7.335-9.497 C243.443,371.603,243.822,370.901,243.924,370.135z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M217.737,299.247c1.525,8.721,2.493,16.625,3.216,22.298c8.257-0.361,39.247-1.974,50.464-6.228 c-1.604-46.992-16.542-74.94-16.542-74.94s-5.525-0.37-11.838,0.085c-0.832,0.055-1.675,0.136-2.53,0.23 c-5.533,0.606-14.43,2.613-20.543,4.158c-1.285,0.326-2.58,0.69-3.837,1.064c-6.396,1.918-11.946,4.262-11.946,4.262 c4.038,9.734,7.081,19.787,9.437,29.316C215.338,286.464,216.674,293.157,217.737,299.247z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M217.554,221.299c2.567,6.349,6.19,18.202,2.414,23.55c4.062,2.806,9.654,4.76,17.047,3.095 c5.662-1.275,5.184-5.31,3.492-7.256c-7.708-0.268-8.57-5.777-8.274-11.174L217.554,221.299z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.163,247.911c0,0-1.594,3.188-3.565,6.422c-4.144-1.195-13.996-4.654-14.689-9.637 c0.184-1.534,1.896-2.802,1.896-2.802S227.43,245.971,237.163,247.911z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.163,247.911c0,0,3.429,1.762,5.992,4.384c2.291-2.444-1.164-11.256-2.392-12.051 c-2.464-0.915-3.905-0.446-3.905-0.446S241.223,245.943,237.163,247.911z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M223.539,224.653l8.688,4.858c-0.074,1.278-0.077,2.56,0.068,3.776 c-2.894,0.163-7.356-2.145-8.221-5.034C223.641,226.812,223.431,225.386,223.539,224.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M213.188,213.448c3.358,8.488,4.892,13.632,10.712,16.608c8.755,4.476,18.141-3.093,17.384-12.441 c-0.681-8.414-6.058-20.882-15.651-21.477C216.181,195.553,209.831,204.96,213.188,213.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M227.102,211.447c0.23,0.706,0.79,1.152,1.251,0.997c0.461-0.155,0.647-0.853,0.417-1.559 c-0.23-0.706-0.79-1.152-1.25-0.997C227.058,210.043,226.872,210.741,227.102,211.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M235.065,208.763c0.23,0.706,0.79,1.152,1.251,0.997c0.461-0.155,0.647-0.853,0.417-1.559 c-0.23-0.706-0.79-1.152-1.251-0.997C235.021,207.359,234.835,208.057,235.065,208.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#630F0F"
    },
    d: "M232.648,209.967c0,0,2.92,3.366,5.32,4.669c-0.87,1.517-3.163,1.696-3.163,1.696L232.648,209.967z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M231.91,220.305c0.302-0.058,0.614-0.14,0.937-0.249c0.114-0.038,0.177-0.162,0.139-0.277 c-0.037-0.115-0.163-0.175-0.274-0.137c-3.096,1.04-5.241-0.635-5.263-0.652c-0.093-0.075-0.231-0.058-0.306,0.036 c-0.075,0.095-0.061,0.232,0.033,0.307C227.262,219.402,229.113,220.846,231.91,220.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M223.807,209.699c0.149-0.029,0.28-0.135,0.333-0.291c0.633-1.849,2.183-2.273,2.199-2.277 c0.233-0.061,0.375-0.3,0.316-0.533c-0.059-0.233-0.296-0.373-0.528-0.313c-0.082,0.021-2.026,0.552-2.81,2.846 c-0.079,0.229,0.042,0.477,0.269,0.554C223.66,209.709,223.735,209.712,223.807,209.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M237.601,204.862c0.081-0.016,0.159-0.055,0.223-0.117c0.173-0.169,0.178-0.447,0.011-0.619 c-1.675-1.728-3.643-1.337-3.734-1.331c-0.236,0.048-0.39,0.279-0.345,0.515c0.045,0.236,0.271,0.389,0.506,0.343 c0.081-0.02,1.601-0.301,2.946,1.086C237.314,204.848,237.463,204.889,237.601,204.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M209.678,265.389c1.496,4.76,2.801,9.493,3.941,14.103c1.253,5.082,2.299,10.008,3.187,14.668 c1.641-9.425,0.643-30.397,0.643-30.397l-5.169-4.988C212.28,258.775,210.901,261.267,209.678,265.389z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#803E3C"
    },
    d: "M234.103,299.877l-4.637,0.519c-1.559,0.157-3.118,0.271-4.66,0.398 c-3.086,0.22-6.147,0.357-9.052,0.267c-1.448-0.04-2.856-0.16-4.142-0.357c-1.277-0.181-2.462-0.483-3.201-0.842 c-0.368-0.171-0.392-0.272-0.379-0.248c0.01,0.014-0.002-0.029-0.003-0.039l-0.04-0.149c-0.034-0.123-0.075-0.305-0.117-0.506 c-0.082-0.414-0.152-0.949-0.196-1.531c-0.17-2.373-0.018-5.333,0.325-8.256c0.351-2.951,0.8-5.978,1.375-9.009 c1.103-6.044,2.496-12.275,3.949-18.207l-13.477-3.643c-0.948,3.311-1.661,6.47-2.382,9.732c-0.722,3.24-1.294,6.52-1.815,9.837 c-0.481,3.324-0.91,6.685-1.11,10.153c-0.171,3.49-0.303,7.007,0.308,11.038c0.16,1.015,0.371,2.069,0.709,3.211 c0.174,0.575,0.371,1.163,0.633,1.79c0.132,0.314,0.265,0.624,0.438,0.96l0.262,0.503l0.353,0.59 c0.983,1.561,2.312,2.741,3.583,3.561c1.276,0.811,2.522,1.295,3.675,1.646c2.316,0.679,4.347,0.845,6.278,0.9 c1.927,0.03,3.747-0.108,5.516-0.308c7.055-0.893,13.373-2.801,19.683-5.354L234.103,299.877z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M201.698,251.518c-7.224,5.08-9.611,31.309-9.611,31.309l22.421,2.719 c0,0,2.729-11.652,2.98-23.065C217.764,250.049,210.448,245.364,201.698,251.518z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M231.82,300.17l6.568-6.639l4.09,11.087c0,0-6.837,4.395-9.557,0.992L231.82,300.17z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "245.98,292.552 248.936,301.874 242.478,304.618 238.388,293.531  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M218.909,220.999l0.577-0.099c1.541-0.265,2.138-2.121,1.082-3.273 c-1.263-1.378-2.501-3.293-2.819-5.695c-0.704-5.318,2.188-6.064,1.815-9.703c0,0,7.235-0.945,11.828-4.111 c0,0,4.507-6.525,0.903-9.605c-3.036-2.595-6.694,0.934-6.694,0.934s-1.558-4.758-5.29-3.732 c-3.869,1.064-5.262,6.144-5.262,6.144s-3.601-3.998-6.307-1.945c-2.706,2.053-1.755,7.215-1.755,7.215s-5.616,0.155-5.802,3.421 s3.172,6.158,3.172,6.158s-3.359,3.14-2.426,5.768c0.933,2.629,3.981,2.893,3.981,2.893s-2.115,4.477-0.622,5.932 c1.493,1.454,4.388,1.081,4.388,1.081s0.09,4.292,3.542,5.505c2.465,0.866,4.148-0.718,4.148-0.718s1.697,2.489,2.773,1.806 S218.909,220.999,218.909,220.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M210.676,225.761c1.971-2.637,8.152-10.558,11.813-11.276c0,0-1.555-1.247-2.41-7.154 c0,0-1.651,3.132-3.764,5.288c-3.313,3.382-6.673,7.708-8.069,9.782C208.246,222.401,208.721,223.889,210.676,225.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M210.676,225.761c1.971-2.637,8.152-10.558,11.813-11.276c0,0-1.555-1.247-2.41-7.154 c0,0-1.651,3.132-3.764,5.288c-3.313,3.382-6.673,7.708-8.069,9.782C208.246,222.401,208.721,223.889,210.676,225.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M212.2,221.759c1.42,2.004,3.634,3.155,5.631,3.448c3.004,0.441,4.147-2.356,3.011-5.005 c-1.022-2.384-3.816-5.487-6.686-4.714C211.329,216.25,210.577,219.468,212.2,221.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M223.013,215.367c0,0,6.531,2.687,11.662-2.217c0,0,5.339,1.444,6.965-1.464l-1.624-0.52 l-16.245,3.552L223.013,215.367z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M239.168,201.014l-17.53,3.66c-0.63,0.131-1.181,0.507-1.533,1.045l-0.421,0.644 c-0.352,0.538-0.476,1.194-0.345,1.823l1.229,5.885c0.274,1.311,1.558,2.152,2.869,1.878l17.529-3.66 c0.629-0.131,1.181-0.508,1.533-1.046l0.421-0.644c0.352-0.538,0.476-1.194,0.345-1.823l-1.229-5.886 C241.763,201.581,240.479,200.74,239.168,201.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M239.168,201.014l-17.53,3.66c-0.63,0.131-1.181,0.507-1.533,1.045l-0.421,0.644 c-0.352,0.538-0.476,1.194-0.345,1.823l1.229,5.885c0.274,1.311,1.558,2.152,2.869,1.878l17.529-3.66 c0.629-0.131,1.181-0.508,1.533-1.046l0.421-0.644c0.352-0.538,0.476-1.194,0.345-1.823l-1.229-5.886 C241.763,201.581,240.479,200.74,239.168,201.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M240.77,210.724l-14.808,3.092c-1.327,0.277-2.627-0.574-2.904-1.901l-0.926-4.437 c-0.277-1.327,0.574-2.627,1.901-2.904l14.808-3.091c1.327-0.277,2.627,0.574,2.904,1.901l0.926,4.437 C242.948,209.147,242.097,210.447,240.77,210.724z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePage);
export default __webpack_public_path__ + "static/media/HomePage.67a1fa4adc68cba41526645646a87653.svg";
export { ForwardRef as ReactComponent };